<script setup>
import { PaginationPrev } from "reka-ui";
import { cn } from "@/shared/lib/utils";
import { buttonVariants } from "@/shared/ui/button";

const props = defineProps({
  size: { type: String, default: "icon-sm" },
  class: { type: [String, Object, Array], default: undefined },
});
</script>

<template>
  <PaginationPrev
    data-slot="pagination-previous"
    :class="
      cn(buttonVariants({ variant: 'ghost', size: props.size }), props.class)
    "
  >
    <slot>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="w-4 h-4"
      >
        <path d="m15 18-6-6 6-6" />
      </svg>
    </slot>
  </PaginationPrev>
</template>
